import React, { useState } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import { Row, Alert } from "reactstrap";
import Moment from 'moment';
import { set } from "react-hook-form";
import { createAutorizaciones, createNotificaciones, createNotificacionesNuevas } from "../../graphql/mutations";

//import { API } from "aws-amplify";
import { GetUsuarios } from "../queries/Queries";
import Produccion from "../produccion/Produccion";
import { generateClient } from "aws-amplify/api";
const API = generateClient();

function Notificar({
    datosReciba,
    mensaje,
    btitle,
    bColor,
    para,
    modulo,
    accion,
    peticionAutTipo,
    tipoNotific,
    usuario,
    paraSoporte,
    valorDeREtorno,
}) {

    const [modalCP, setModalCP] = useState(false);
    const toggleCP = () => setModalCP(!modalCP);
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const onDismiss = () => setAVisible(false);

    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();
    now2.setMonth(now2.getMonth() - 1);



    function cerrar() {
        valorDeREtorno({ completo: true });
        toggleCP();
    }


    async function registrarNotificacion() {
        //Filtro
        let filterReciba = {
            and: [{ activo: { eq: true } },
            { Notificaciones: { eq: true } },
            {
                or: [{ Reciba: { eq: true } },
                { Incoming: { eq: true } }
                ]
            },
            { usuario: { ne: usuario } }
            ]
        };
        let filterIncoming = {
            and: [{ activo: { eq: true } },
            { Notificaciones: { eq: true } },
            { Incoming: { eq: true } },
            { usuario: { ne: usuario } }
            ]
        };
        let filterProduccion = {
            and: [{ activo: { eq: true } },
            { Notificaciones: { eq: true } },
            { Produccion: { eq: true } },
            { usuario: { ne: usuario } }
            ]
        };
        let filterInspeccionF = {
            and: [{ activo: { eq: true } },
            { Notificaciones: { eq: true } },
            { ProduccionCalidad: { eq: true } },
            { usuario: { ne: usuario } }
            ]
        };
        let filter = {
            and: [{ activo: { eq: true } },
            { Notificaciones: { eq: true } },
            { TicketsSoporte: { eq: true } },
            { usuario: { ne: usuario } }
            ]
        };
        setCargando(true);
        const usuariosNot = await GetUsuarios(para === "Reciba" ? filterReciba : para === "Incoming" ? filterIncoming : para === "Producción" ? filterProduccion : para === "InspeccionC" ? filterInspeccionF : filter);
        const nombres = usuariosNot.map(u => u.usuario).join(',');
        //Notificaciones para el soporte
        const notificaciones = {
            recibaSerialID: datosReciba.recibaSerialID,
            modulo: modulo,
            Accion: accion,
            notificacion: mensaje,
            fecha: Moment(new Date()).format("YYYY-MM-DD"),
            hora: Moment(new Date()).format("HH:mm"),
            leido: false,
            usuarioDe: usuario,
            usuarioPara: "," + nombres + ",",
            paraSoporte: paraSoporte,
            tipo: tipoNotific,
            activo: true,
            Reg_Ins_Usuario: usuario
        };

        if (para === "Producción" || para === "InspeccionC") {
            let filterAutProduccion = {
                and: [{ activo: { eq: true } },
                {
                    or: [{ AutorizarCalidad: { eq: true } },
                    { AutorizarTodo: { eq: true } }]
                },
                { usuario: { ne: usuario } }
                ]
            };
            let filterAutInspeccionF = {
                and: [{ activo: { eq: true } },
                {
                    or: [{ AutorizarEmbarques: { eq: true } },
                    { AutorizarTodo: { eq: true } }]
                },
                { usuario: { ne: usuario } }
                ]
            };
            const usuarioAutoreza = await GetUsuarios(para === "Producción" ? filterAutProduccion : filterAutInspeccionF);
            const nombresConcatenados = usuarioAutoreza.map(u => u.nombreCompleto).join(", ");
            //Tambien se crea un registro nuevo en la tabla de Autorizaciones
            const datosAutorizacion = {
                recibaSerialID: datosReciba.recibaSerialID,
                clienteID: datosReciba.clienteID,
                cliente: datosReciba.cliente,
                productoID: datosReciba.productoID,
                numerodeParte: datosReciba.numerodeParte,
                descripcion: datosReciba.descripcion,
                serial: datosReciba.serial,
                serialRecibaBTI: datosReciba.serialRecibaBTI,
                peticionTipo: peticionAutTipo,
                peticionModulo: modulo,
                peticionMotivos: mensaje,
                peticionFecha: Moment(new Date()).format("YYYY-MM-DD"),
                peticionHora: Moment(new Date()).format("HH:mm"),
                peticionUsuario: usuario,
                peticionUAutorizar: nombresConcatenados,
                activo: true,
                cancelado: false,
                Reg_Ins_Usuario: usuario,
            }
            setMensajeAlert("Problemas al guardar la solicitud de la autorización");//+ JSON.stringify(datosAutorizacion)
            let regisAutoriza = await API.graphql({ query: createAutorizaciones, variables: { input: datosAutorizacion } });
            notificaciones.autorizacion = (para === "Producción" || para === "InspeccionC") ? true : false;
            notificaciones.autorizacionID = regisAutoriza.data.createAutorizaciones.id;

        }

        setMensajeAlert("No fue posible realizar la operación: error al guardar las notificaciones" + JSON.stringify(notificaciones));
        let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
        //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
        notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
        await Promise.all(
            usuariosNot.map(async (not, i) => {
                const notific = { ...notificaciones, usuarioPara: not.usuario };
                //Se establece para qué usuario es la notificación                    
                await API.graphql({ query: createNotificacionesNuevas, variables: { input: notific } });
            })
        );

        setCargando(false);
        valorDeREtorno({ completo: true });

    }

    return (
        <>
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                {mensajeAlert}
            </Alert>
            {!cargando && (
                <button
                    class={"btn-" + bColor + " cbutton"}
                    title={btitle}
                    //style={{ display: "none" }}
                    onClick={() => registrarNotificacion()}
                >
                    <IoIcons.IoIosChatbubbles />
                </button>
            )}
            {cargando === true && (
                <Row>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                        <img width="150px" src="assets/img/preloader.gif" />
                    </div>
                </Row>
            )}
        </>
    );
}
export default Notificar;
